// File preserved for backward compatibility.
// TODO [MAJOR]: Delete this file if no more commands appear here.
export {resetHeading, toHeading} from '../../markdown/Heading/commands';
